<template>
  <div>
    <el-row class="mr-b30">
      <!--로그 그룹 버튼-->
      <el-row class="title-bar">
        <div class="vertical-center-box">
          <div class="title-h3 mr-r15">로그 그룹</div>
          <!--로그 그룹 추가-->
          <div class="setting-addel">
            <el-button size="mini" @click="showAddLogGroupPopup"><i class="fas fa-plus"></i></el-button>
            <el-button size="mini" @click="deleteGroup" :disabled="!groupCheckFlag"><i class="fas fa-minus"></i></el-button>
          </div>
        </div>
      </el-row>
      <!--테이블-->
      <el-row>
        <el-table-wrapper :column-default="columnDefault" row-class-name="c-dblclick" border :data="tableData" :columns="logGroupList" :pagination="false"
          :show-custom-header="false" ref="applogGroupTable" header-align="center" highlight-current-row  @cell-dblclick="showApplogGroupUpdatePopup" @cell-click="showLogListInGroup" @selection-change="checkGroupSelection">
        </el-table-wrapper>
      </el-row>
    </el-row>

    <el-row>
      <!-- 그룹내 기본 설정 로그-->
      <el-row class="title-bar" type="flex" justify="space-between">
        <div class="vertical-center-box">
          <div class="title-h3 mr-r15">그룹 내 기본 설정 로그</div>
          <div class="setting-addel">
            <el-button size="mini" :disabled="!checkLogGroup" @click="showAddLogPopup"><i class="fas fa-plus"></i></el-button>
            <el-button size="mini" :disabled="!checkLogFlag" @click="deleteApplog"><i class="fas fa-minus"></i></el-button>
          </div>
        </div>
        <div class="vertical-center-box" align="right">
          <el-button :disabled="!checkSelectLog" @click="showLogtreeListPopup" type="primary" size="mini">그룹저장</el-button>
        </div>
      </el-row>
      <!--테이블-->
      <el-row>
          <el-table-wrapper :column-default="columnDefault" row-class-name="c-dblclick"  border :data="nodeTableData" :columns="logNodeList" :pagination="false"
            :show-custom-header="false" ref="applogIngroupTable" header-align="center" highlight-current-row @cell-dblclick="showUpdateApplogPopup" @selection-change="checkBoxSelection">
            <template slot-scope="scope" slot="applogType-slot">
              <span v-if="scope.row.applogType === 'T'">텍스트</span>
              <span v-else-if="scope.row.applogType === 'B'">바이너리</span>
              <span v-else>MySql Load</span>
            </template>
            <template slot-scope="scope" slot="patternFlag-slot">
              <span v-if="scope.row.patternFlag === 'N'">고정형</span>
              <span v-else>패턴형</span>
            </template>
            <template slot-scope="scope" slot="label-slot">
              <span v-if="scope.row.label === 'DF'">DB.File</span>
              <span v-else-if="scope.row.label === 'D'">DB</span>
              <span v-else-if="scope.row.label === 'F'">File</span>
              <span v-else>NONE</span>
            </template>
            <template slot-scope="scope" slot="applogFileAttrib-slot">
              <span v-if="scope.row.applogFileAttrib === 'F'">파일</span>
              <span v-else>디렉토리</span>
            </template>
            <template slot-scope="scope" slot="applogRawDelInteval-slot">
              <span v-if="scope.row.applogRawDelInteval === 'D'">일간</span>
              <span v-else-if="scope.row.applogRawDelInteval === 'W'">주간</span>
              <span v-else-if="scope.row.applogRawDelInteval === 'M'">월간</span>
              <span v-else-if="scope.row.applogRawDelInteval === 'Y'">연간</span>
              <span v-else>-</span>
            </template>
            <template slot-scope="scope" slot="applogRealtimeSendFlag-slot">
              <span v-if="scope.row.applogRealtimeSendFlag === '1'"><el-checkbox checked disabled></el-checkbox></span>
              <span v-else><el-checkbox disabled></el-checkbox></span>
            </template>
            <template slot-scope="scope" slot="applogRawDelFlag-slot">
              <span v-if="scope.row.applogRawDelFlag === '1'"><el-checkbox checked disabled></el-checkbox></span>
              <span v-else><el-checkbox disabled></el-checkbox></span>
            </template>
          </el-table-wrapper>
      </el-row>
    </el-row>
    <w-app-log-popup ref="appLogPopup" @addApplogInGroup="addApplogInGroup" :type="type" :settingData="settingData" :selectApplogGroup="params"></w-app-log-popup>
    <w-app-log-group-popup ref="appLogGroupPopup" @loadData="loadData" :logGroupFormData="settingData" :type="type"></w-app-log-group-popup>
    <w-app-log-tree-list-popup ref="appLogTreeListPopup" :checkList="checkList" :selectPhysicalNode="selectPhysicalNode" type="log"></w-app-log-tree-list-popup>
  </div>
</template>

<script>
import ApplogSettingAPI from '@/api/settings/log/app-log-setting';
import WTextField from '@/components/formeditor/TextFormEditor';
import isNil from 'lodash/isNil';
import isEmpty from 'lodash/isEmpty';

import cloneDeep from 'lodash/cloneDeep';
import msgUtil from '@/utils/message';
import { columnDefault } from '@/constants/table';
import WAppLogPopup from '../popup/AppLogPopup';
import WAppLogGroupPopup from '../popup/AppLogGroupPopup';
import WAppLogTreeListPopup from '../popup/AppLogTreeListPopup';

export default {
  name: 'WLogFileSetting',
  components: {
    WAppLogPopup,
    WAppLogGroupPopup,
    WTextField,
    WAppLogTreeListPopup,
  },
  data() {
    return {
      columnDefault,
      type: 'Add',
      popoverFlag: false,
      treeData: null,
      checkGroup: false,
      checkPhysicalNode: false,
      checkLogGroup: false,
      params: {},
      settingData: {},
      logGroupFormData: {},
      searchNodeInput: '',
      fieldSelectNode: '',
      fieldSelect: '',
      searchInput: '',
      groupValue: '',
      nodeValue: '',
      nodeTableData: [],
      fieldSelectNodeList: [],
      tableData: [],
      logNodeList: [
        {
          align: 'center',
          headerAlign: 'center',
          type: 'selection',
          width: '50px',
          prop: 'check_flag',
        },
        {
          label: '로그 설정',
          headerAlign: 'center',
          childColumns: [
            {
              prop: 'applogId',
              label: '로그아이디',
            },
            {
              prop: 'applogType',
              label: '로그타입',
              scopedSlot: 'applogType-slot',
            },
            {
              prop: 'applogDir',
              label: '로그경로',
            },
            { prop: 'patternFlag',
              label: '타입',
              scopedSlot: 'patternFlag-slot',
            },
            { prop: 'applogFile',
              label: '로그 파일명',
            },
            { prop: 'label',
              label: '로그 저장',
              scopedSlot: 'label-slot',
            },
            { prop: 'applogFileAttrib',
              label: '파일/디렉토리',
              scopedSlot: 'applogFileAttrib-slot',
            },
          ],
        },
        {
          label: '원시로그',
          headerAlign: 'center',
          childColumns: [
            {
              prop: 'applogRealtimeSendFlag',
              label: '실시간 전송',
              scopedSlot: 'applogRealtimeSendFlag-slot',
            },
            {
              prop: 'applogRawDelFlag',
              label: '삭제 수행',
              scopedSlot: 'applogRawDelFlag-slot',
            },
            {
              prop: 'applogRawDelInteval',
              label: '삭제 주기',
              scopedSlot: 'applogRawDelInteval-slot',
            },
          ],
        },
        { prop: 'orderbyIndex', label: '정렬순서' },
      ],
      logGroupList: [
        {
          align: 'center',
          headerAlign: 'center',
          type: 'selection',
          width: '50px',
          prop: 'check_flag',
        },
        { prop: 'applogGroupId', label: '로그 그룹 아이디' },
        { prop: 'applogGroupName', label: '로그 그룹명' },
        { prop: 'applogCount', label: '그룹내 로그 개수' },
        { prop: 'orderbyIndex', label: '정렬순서' },
      ],
      fieldSelectList: [
        { value: 'Field1', label: 'Field1' },
        { value: 'Field2', label: 'Field2' },
      ],
      groupOptions: [
        { value: 'test1', label: 'test1' },
        { value: 'test2', label: 'test2' },
      ],
      nodeOptions: [
        { value: 'testNode1', label: 'testNode1' },
        { value: 'testNode2', label: 'testNode2' },
      ],
      checkList: [],
      checkGroupList: null,
      checkSelectLog: false,
      groupCheckFlag: false,
      checkLogFlag: false,
    };
  },
  props: {
    selectPhysicalNode: {
      type: Object,
    },
  },
  watch: {
    checkList() {
      if (Object.values(this.checkList).length > 0) {
        this.checkSelectLog = true;
      } else {
        this.checkSelectLog = false;
      }
    },
    selectPhysicalNode() {
      if (!isNil(this.selectPhysicalNode.serverId)) {
        this.checkPhysicalNode = true;
        this.loadData();
      } else {
        this.checkPhysicalNode = false;
        this.checkGroup = false;
        this.tableData = [];
        this.nodeTableData = [];
      }
    },
  },
  methods: {
    /**
     * 그룹 저장 팝업
     * @author leesy918
     * @return {[type]} [description]
     */
    showLogtreeListPopup() {
      this.$refs.appLogTreeListPopup.open();
    },
    /**
     * 그룹 추가 팝업
     * @author leesy918
     * @return {[type]} [description]
     */
    showAddLogGroupPopup() {
      if (isNil(this.selectPhysicalNode.serverId)) {
        this.$message(msgUtil.getRequireInfoMsg(msgUtil.action.SELECT, '서버'));
      } else {
        this.type = 'Add';
        this.settingData = {};
        this.$refs.appLogGroupPopup.open();
      }
    },
    /**
     * 그룹 수정 팝업
     * @author leesy918
     * @param  {[type]} row [description]
     * @return {[type]}     [description]
     */
    showApplogGroupUpdatePopup(row) {
      this.type = 'Update';
      this.settingData = cloneDeep(row);
      this.$refs.appLogGroupPopup.open();
    },
    /**
     * 그룹 삭제
     * @author leesy918
     * @return {[type]} [description]
     */
    deleteGroup() {
      this.$confirm(...msgUtil.getBasicConfirmData(msgUtil.action.DELETE)).then(() => {
        ApplogSettingAPI.deleteApplogGroup(this.checkGroupList).then((response) => {
          if (response.data.success) {
            // 응답 데이터 처리
            this.$message(msgUtil.getResultMsgData(msgUtil.action.DELETE, '로그 그룹', true));
            this.loadData();
            this.nodeTableData = [];
            this.checkGroup = false;
          }
        });
      });
    },
    /**
     * 그룹 체크박스 설정
     * @author leesy918
     * @param  {[type]} data [description]
     * @return {[type]}      [description]
     */
    checkGroupSelection(data) {
      this.checkGroupList = data;
      this.groupCheckFlag = (this.checkGroupList.length > 0);
    },
    /**
     * 체크박스 설정
     * @author leesy918
     * @param  {[type]} data [description]
     * @return {[type]}      [description]
     */
    checkBoxSelection(data) {
      this.checkLogFlag = (data.length > 0);
      this.checkList = data;
    },
    /**
     * 그룹 안 로그 삭제
     * @author leesy918
     * @return {[type]} [description]
     */
    deleteApplog() {
      this.$confirm(...msgUtil.getBasicConfirmData(msgUtil.action.DELETE)).then(() => {
        ApplogSettingAPI.deleteApplogInGroup(this.checkList).then((response) => {
          if (response.data.success) {
            // 응답 데이터 처리
            this.$message(msgUtil.getResultMsgData(msgUtil.action.DELETE, '로그', true));
            this.getLogListInGroup();
            this.loadData();
          }
        });
      });
    },
    /**
     * 로그 그룹 리스트 조회
     * @author leesy918
     * @return {[type]} [description]
     */
    loadData() {
      this.params.serverId = this.selectPhysicalNode.serverId;
      ApplogSettingAPI.getApplogList(this.params).then((response) => {
        if (response.data.success) {
          // 응답 데이터 처리
          this.tableData = response.data.data;
          this.checkLogGroup = !isEmpty(this.tableData);
          this.$nextTick(() => {
            this.$refs.applogGroupTable.$children[0].setCurrentRow(this.tableData[0]);
            this.showLogListInGroup(this.tableData[0]);
          });
        }
      });
    },

    /**
     * 로그 추가 팝업 출력
     * @author leesy918
     * @return {[type]} [description]
     */
    showAddLogPopup() {
      if (isNil(this.selectPhysicalNode.serverId)) {
        this.$message(msgUtil.getRequireInfoMsg(msgUtil.action.SELECT, '로그 그룹'));
      } else {
        this.type = 'Add';
        this.settingData = {};
        this.$refs.appLogPopup.open();
      }
    },
    /**
     * 그룹내 기본설정 로그 조회
     * @author leesy918
     * @param  {[type]} row [description]
     * @return {[type]}     [description]
     */
    showLogListInGroup(row) {
      if (!isNil(this.selectPhysicalNode.serverId) && (!isNil(row))) {
        this.params.serverId = this.selectPhysicalNode.serverId;
        this.params.applogGroupId = row.applogGroupId;
        this.getLogListInGroup();
        this.checkGroup = true;
      } else {
        this.checkGroup = false;
      }
    },
    /**
     * 그룹 내 기본설정 로그 수정
     * @author leesy918
     * @param  {[type]} row [description]
     * @return {[type]}     [description]
     */
    showUpdateApplogPopup(row) {
      this.type = 'Update';
      this.settingData = cloneDeep(row);
      this.$refs.appLogPopup.open();
    },
    /**
     * 기본설정 로그 조회
     * @author leesy918
     * @return {[type]} [description]
     */
    getLogListInGroup() {
      ApplogSettingAPI.getApplogSet(this.params).then((response) => {
        if (response.data.success) {
          this.nodeTableData = response.data.data;
        }
      });
    },
    addApplogInGroup() {
      this.loadData();
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/settings/log/Applog/component/LogFileSetting.vue